import { Button } from "react-bootstrap";
import { useNavigate } from "react-router";
import { Column, Row } from "../../components/grid";
import Header from "../../components/header/Header";
import { TableWithQueryPaginationAndSort } from "../../components/table/TableWithQueryPaginationAndSort";
import { Icon } from "../../modules/icon";
import { screens } from "../Navigation.types";
import { useChatTableReport } from "./useChatTableReport";

export function ChatTableReport({ reportId }: { reportId: string }) {
  const {
    reportTableData,
    reportTableHeaders,
    reportTableMetaData,
    loading,
    reportName,
  } = useChatTableReport({ reportId });

  const navigate = useNavigate();
  return (
    <div style={{ padding: "20px" }}>
      <Header
        title={reportName || "Report"}
        size="h5"
        actions={
          <Button
            className="btn btn-secondary"
            onClick={() => {
              const sessionId = window.location.pathname.match(
                /\/chatbot\/sessionId\/([^/]+)/
              )?.[1];
              if (sessionId) {
                navigate(`/chatbot/sessionId/${sessionId}`);
              } else {
                navigate(screens.chatbot);
              }
            }}
          >
            <Icon type="fa fa-backward" />
            &nbsp; Back to conversation
          </Button>
        }
      />
      <div style={{ height: "20px" }}></div>
      <Row>
        <Column>
          <div className="my-2 w-100">
            <TableWithQueryPaginationAndSort
              headers={reportTableHeaders}
              data={reportTableData}
              totalItems={reportTableMetaData.totalCount || 0}
              onRowPress={() => {}}
              loading={loading}
            />
          </div>
        </Column>
      </Row>
    </div>
  );
}
